import React from "react";
import { Box, Grid, Button } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

export default function LoadFIleView(props) {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sx={{
            alignItems: "center",
            textAlign: "center",
            marginTop: "20%",
          }}
        >
          <Button variant="contained" component="label" endIcon={<UploadIcon />}>
            Carregar Arquivo{/* trad */}
            <input
              id="file"
              type="file"
              hidden
              onChange={(e) => props.handleUploadFile(e)}
              onClick={(e) => {
                e.target.value = null;
              }}
            />
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
